import React from 'react';
import { motion } from 'framer-motion';
export function Section({
  children,
  className = '',
  bg = 'bg-brand-cream'
}: {
  children: React.ReactNode;
  className?: string;
  bg?: string;
}) {
  return <section className={`py-16 md:py-24 px-6 ${bg} ${className}`} data-id="element-137">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-138">
        {children}
      </motion.div>
    </section>;
}